import App from "./openAccount.vue";
import appInit from "../shared/app-init"

if ($("#openAccountHolder").is(":visible")){
  appInit(App, "#openAccountHolder", true);
}